const formatCurrency = (value: number | string): string => {
  const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  return Number(value || 0).toLocaleString('en', options);
};

export default formatCurrency;
